"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _taggedTemplateLiteral2 = require("babel-runtime/helpers/taggedTemplateLiteral");

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(["\n\tquery GetAllOrgs {\n\t\tviewer {\n\t\t\tuser {\n\t\t\t\tid\n\t\t\t\tpersonal {\n\t\t\t\t\tid\n\t\t\t\t}\n\t\t\t\tmemberOf {\n\t\t\t\t\tedges {\n\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tadminOf {\n\t\t\t\t\tedges {\n\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"], ["\n\tquery GetAllOrgs {\n\t\tviewer {\n\t\t\tuser {\n\t\t\t\tid\n\t\t\t\tpersonal {\n\t\t\t\t\tid\n\t\t\t\t}\n\t\t\t\tmemberOf {\n\t\t\t\t\tedges {\n\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t\tadminOf {\n\t\t\t\t\tedges {\n\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\tid\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _ramda = require("ramda");

var _ramda2 = _interopRequireDefault(_ramda);

var _reactRouter = require("react-router");

var _recompose = require("recompose");

var _reactApollo = require("react-apollo");

var _button = require("./button");

var _button2 = _interopRequireDefault(_button);

var _styles = require("./styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//------------------------------

var getAllOrgs = (0, _reactApollo.gql)(_templateObject);

// --------------------------------------------------

var enhance = (0, _recompose.compose)((0, _reactApollo.graphql)(getAllOrgs, {
	name: "getAllOrgs"
}), _reactRouter.withRouter, (0, _recompose.withPropsOnChange)(["getAllOrgs"], function (props) {
	return {
		orgIDs: _ramda2.default.pipe(_ramda2.default.path(["getAllOrgs", "viewer", "user"]), _ramda2.default.evolve({
			memberOf: _ramda2.default.propOr([], "edges"),
			adminOf: _ramda2.default.propOr([], "edges")
		}), _ramda2.default.pick(["memberOf", "adminOf"]), _ramda2.default.values, _ramda2.default.flatten, _ramda2.default.map(_ramda2.default.path(["node", "id"])), _ramda2.default.filter(_ramda2.default.identity), _ramda2.default.uniqBy(_ramda2.default.identity))(props),

		personalOrgID: _ramda2.default.path(["getAllOrgs", "viewer", "user", "personal", "id"])(props)
	};
}), (0, _recompose.withPropsOnChange)(["getAllOrgs"], function (props) {
	return {
		allIDs: [props.personalOrgID].concat((0, _toConsumableArray3.default)(props.orgIDs))
	};
}), (0, _recompose.withPropsOnChange)(["allIDs", "match"], function (props) {
	return {
		activeOrgIndex: props.allIDs.findIndex(function (id) {
			return id && id === _ramda2.default.path(["match", "params", "orgID"])(props);
		})
	};
}));

exports.default = enhance(function (props) {
	return _react2.default.createElement(
		_styles.Sidebar,
		null,
		_react2.default.createElement(_button2.default, { isUser: true, id: props.personalOrgID }),
		props.getAllOrgs.loading ? _ramda2.default.times(_ramda2.default.identity, 3).map(function (i) {
			return _react2.default.createElement(_button2.default, { isPlaceholder: true, key: i });
		}) : props.orgIDs.map(function (orgID) {
			return _react2.default.createElement(_button2.default, { isOrg: true, key: orgID, id: orgID });
		}),
		_react2.default.createElement(_button2.default, { isAddNew: true }),
		props.activeOrgIndex > -1 ? _react2.default.createElement(_styles.Arrow, { index: props.activeOrgIndex }) : null
	);
});

//# sourceMappingURL=sidebar.js.map


//////////////////
// WEBPACK FOOTER
// ./~/codogo-react-widgets/dist/components/shell/sidebar.js
// module id = 381
// module chunks = 0